import { fillAndDownload } from "./pdfFiller"

/**
 * Mixin for the insurance/medical PDF forms. `fillAndPersist` generates and
 * downloads the PDF exactly as before, then archives the submission against
 * the current patient so it can be viewed and reprinted later.
 *
 * The PDF itself is not stored — we persist the raw form state (`data`, from
 * the component's `this.form`) and a snapshot of the fill payload
 * (`render_payload`) so reprinting reproduces the original output without
 * depending on the component or on later coordinate re-calibration.
 *
 * Saving never blocks the download: if the PDF generates but the archive call
 * fails, the user still gets their file and a non-blocking warning.
 */
export default {
    methods: {
        async fillAndPersist(meta, payload) {
            await fillAndDownload(payload)
            try {
                await this.$store.dispatch("patientForms/savePatientForm", {
                    form_key: meta.form_key,
                    title: meta.title,
                    data: this.form,
                    render_payload: payload,
                })
            } catch (e) {
                this.$bvToast.toast(
                    "The PDF was generated but could not be saved to the patient's record.",
                    { title: "Could not archive form", variant: "warning" }
                )
            }
        },
    },
}
